<ng-template #settingsTemplate>
    <app-tool-setting label="Munt- en briefgeld">
        <app-svg-input
            [options]="svgList"
            [parent]="instance"
        ></app-svg-input>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <!-- This tool has no content -->
</ng-template>
